import { Layout } from "@singularsystems/neo-canvas-grid";
import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import IssuerInvestmentAutoComplete from "../../../Domain/Components/IssuerInvestmentAutoComplete";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import InvestorAccrualCriteria from "./InvestorAccrualCriteria";

@NeoReport("InvestorAccrual", { category: ReportCategory.InvestorReports })
export default class InvestorAccrualReport extends Report<InvestorAccrualCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(InvestorAccrualCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2} lg={3}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.entityId} select={{itemSource: this.dataCache.entities}} />
                    <Neo.FormGroup>
                        <IssuerInvestmentAutoComplete
                            bind={this.criteria.meta.issuerInvestmentId}
                            bindDisplay={this.criteria.meta.issuerInvestmentName}
                            entityId={this.criteria.entityId}
                            useParentCache={true} />
                    </Neo.FormGroup>
                </div>
            </Neo.GridLayout>
        </div>;
    }

    public getDefaultGridLayout(criteria?: InvestorAccrualCriteria | undefined, propertyKey?: string | undefined): Layout.IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "accrual.averageRate",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "accrual.averageCapital"
                        }
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}